import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {configMyModules_template} from "../components/templates/configMyModules_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class config_my_modules extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected elementsList: configMyModules_template;

    protected getModuleName(){

        return "config_my_modules";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.elementsList = new configMyModules_template("list", this.viewModel, this);

        //only show Add Job Profile button if CM or Admin
        let vnApp = this.getVnAppZone().app;
        let roles = vnApp.loggedUser.user.valnet_user.roles;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("My Modules");

        return [this.elementsList.build()];
    }

    public fillPage() : void{

        this.getModules();
    }

    protected getModules(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/config/my-modules/";

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){


        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });
            obj.loadingOut(obj.elementsList.builtTemplate);
        }
    }

    // update the module list using the objects list
    protected updateList(responseParsed: any){

        this.elementsList.setModules(responseParsed.modules);
        if (responseParsed.tagTypesLabelMapping) {
            this.elementsList.setTagTypesLabelNameMapping(responseParsed.tagTypesLabelMapping);
        }else{
            this.elementsList.createTagTypesLabelNameMappingFromViewModel();
        }
    }

    protected save(){

        this.loadingIn(this.elementsList.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/config/my-modules/save";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = this.elementsList.getTemplateViewModel().modules;
        const tagTypesLabelMapping = ko.toJSON(this.elementsList.getTemplateViewModel().tagTypesLabelMapping())
        const uniqueTagTypeList = ko.toJSON(this.elementsList.getUniqueTagTypesFromModules())

        formReq_params.push(["data", ko.toJSON(subViewModel)]);
        formReq_params.push(["tagTypesLabelMapping", tagTypesLabelMapping]);
        formReq_params.push(["uniqueTagTypeList", uniqueTagTypeList]);
        formReq_params.push(['name' , 'tagTypesLabelMapping']);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSaveReturn;

        XHRHdl.execute();
    }

    protected onSaveReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "SAVED!");
                obj.getVnAppZone().showNotificationToModule();

                obj.getModules();
            });
            obj.loadingOut(obj.elementsList.builtTemplate);
        }
    }

    public cancelChanges(){

        //refresh the page, no changes
        this.getModules();
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Changes cancelled!");
        this.getVnAppZone().showNotificationToModule();
    }

    public getTagTypesSuggestion(keyword, idElement) {

        this.XHRHdl.cancelAndReset();

        let subViewModel = {pagination: {itemPerPage: 25}, filter: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/search/tag/type/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetTagTypesSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagTypesSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data.tagTypes) {
                    obj.elementsList.setTagTypeFilter(response.data.idElement, response.data.tagTypes);
                }
            });
        }
    }

    public filterSimpleOnChange(idElement): void {

        this.elementsList.addTagType();
    }

    public deleteModule(idEditedModule): void {

        this.loadingIn(this.elementsList.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/config/my-modules/delete";
        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(["idEditedModule", idEditedModule]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSaveReturn;

        XHRHdl.execute();
    }

    public saveTagTypesLabelMapping(){

        this.loadingIn(document.getElementById("label-name-dialog-content"));
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        const endpoint = '/api/brand/' + idBrand + "/config/my-modules/tag-types-label-mapping/";
        const params: Array<Array<string>> = [];

        const tagTypesLabelMapping = ko.toJSON(this.elementsList.getTemplateViewModel().tagTypesLabelMapping())
        const uniqueTagTypeList = ko.toJSON(this.elementsList.getUniqueTagTypesFromModules())

        params.push(['tagTypesLabelMapping' , tagTypesLabelMapping]);
        params.push(['uniqueTagTypeList' , uniqueTagTypeList]);
        params.push(['name' , 'tagTypesLabelMapping']);

        if(this.elementsList.getTemplateViewModel().tagTypesLabelMapping().length == 0){
            this.elementsList.toggleLabelNameDialogVisibility()
            this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, "No tag types mapping provided!");
            this.getVnAppZone().showNotificationToModule();
            this.loadingOut(document.getElementById("label-name-dialog-content"));
            return;
        }

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(endpoint, params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSaveTagTypesLabelMappingReturn;
        XHRHdl.execute();
    }

    public onSaveTagTypesLabelMappingReturn(req, obj) {
        return function () {

            obj.manageResponse(req, obj, function () {
                if (req.request.status == 200) {
                    obj.elementsList.getTemplateViewModel().cloneTagTypesLabelMapping([]);
                    obj.elementsList.toggleLabelNameDialogVisibility()

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Config Saved!");
                    obj.getVnAppZone().showNotificationToModule();
                }else{
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, "Config not saved!");
                    obj.getVnAppZone().showNotificationToModule();
                }

            });
            obj.loadingOut(document.getElementById("label-name-dialog-content"));
        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/config_my_modules.ts